
















import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  changeFieldVal() {
    this.changeFieldValue(
      this.form,
      {
        tblname: "stadium",
        fieldname: "remark",
        fieldlabel: "备注",
        isRequired: true,
        content: "修改场馆备注",
        primaryname: "id",
        primaryval: this.stadiumId,
        oldval: this.formData.remark,
        notice: "0",
      },
      "admin-stadiums-edit"
    );
  }

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("enterapply/detail", {
      stadium_id: this.stadiumId,
    });
    if (res && res.Data && res.Data != "{}") {
      this.formData = res.Data;
    }
    this.spinLoading = false;
  }
}
